///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/client-type.collection.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    export class ProductsWithCategoriesAndBundles extends DataTemplateBase implements IDataTemplate {
        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        private readonly _products: CollectionOptimizedApi<Model.Variant>;
        private readonly _productCategories: CollectionOptimizedApi<Model.ProductCategory>;
        private readonly _productCategoriesBundlesStrategy: CoreProductVariantToCategoryStrategy;

        get collection() {
            return this._productCategories;
        }

        get leafCollection() {
            return this._products;
        }

        constructor(model: Dictionary<any>, properties: string[], private options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.totalSelectedMessage = null;

            this._products = new CollectionOptimizedApi(this.model[properties[0]], [], {
                SmartMoverModel: VariantModel,
                url: 'productvariant',
                criteria: {
                    variantObjectState: [ObjectStateEnum.Active, ObjectStateEnum.Inactive]
                },
                smartMoverHidden: () => this.smartMoverHidden,
            }, options.$scope);
            this._productCategories = new CollectionOptimizedApi(this.model[properties[1]], [], {
                CategoryModel: VirtualRepeatCategory,
                url: 'productCategory',
                smartMoverHidden: () => this.smartMoverHidden,
            }, options.$scope);

            this._productCategoriesBundlesStrategy = new CoreProductVariantToCategoryStrategy(
                this._productCategories,
                this._products,
            );
            this._products.setParentCollection(this._productCategories, this._productCategoriesBundlesStrategy);

            this.title = 'LABEL_PRODUCTS';
            this.allSelectedLabel = 'LABEL_ALL_PRODUCTS';

            if (options.required) {
                this.validation.push(new RequiredValidation(this._products, 'LABEL_PRODUCTS_REQUIRED'));
            }

            this.filters = [
                new IncludeObjectStateFilter({
                    displayName: 'LABEL_MOVER_INCLUDE_DISCONTINUED',
                    filterProperty: 'varObjectState',
                    stateList: [ObjectStateEnum.Active, ObjectStateEnum.Inactive],
                    defaultValue: options.defaultFilterValue || false,
                }, this)
            ];
            this._products.addFilters(...this.filters as IInteractiveFilter[]);
        }

        setWatchers(scope: angular.IScope) {
            this._productCategories.setWatchers(scope);

            super.setWatchers(scope);
        }

        fetch(dataService: Meevo.Components.BaseClasses.IDataService): angular.IPromise<any> {
            const { $q } = this.options;

            return $q.all([
                this._productCategories.fetch(dataService),
                dataService.getListPaged('productBundles', {
                    criteria: {
                        businessTypeList: null,
                        locationList: null,
                        hierarchyId: null,
                        branchId: null,
                        objectStateEnumList: [ObjectStateEnum.Active],
                        displayName: null,
                        fieldOrderBy: 'DisplayName',
                        orderAscDesc: 'Ascending'
                    }, itemsPerPage: 50000
                })
            ]).then(([_any, bundles]) => {
                if (bundles.length > 0) {
                    this._productCategories.pushObjects([{
                        displayName: 'Product Bundles',
                        id: 'productBundles',
                    }]);

                    this._products.pushObjects(bundles.map(bundle => {
                        return {
                            ...bundle,
                            varObjectState: ObjectStateEnum.Active,
                            categoryId: 'productBundles'
                        } as any
                    }));
                }
                this._productCategoriesBundlesStrategy.populate();
            });
        }
    }
}
